import {
    Component,
    h,
    Host,
    Prop,
} from '@stencil/core';
import { ThemeType } from '@uipath/portal-shell-util';

import store from '../../store/store';
import { getTheme } from '../../utils/themeHelper';

@Component({
    tag: 'portal-sheet',
    styleUrl: 'portal-sheet.scss',
    shadow: true,
})
export class PortalSheet {
    /**
    * Theme of the Shell
    * @memberof PortalSheet
    */
    @Prop() theme: ThemeType = 'autoTheme';

    render() {
        return (
            <Host class={getTheme(store, this.theme)}>
                <div class="pt-sheet">
                    <slot></slot>
                </div>
            </Host>
        );
    }
}
